import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import 'react-table/react-table.css';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import {
  requestOutreaches,
} from '../../../store/outreach/OutreachActions';
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import { hashHistory } from 'react-router';
import Moment from '../../../components/utils/Moment';
import { hostTitle } from '../../../config/ui';

class OutreachManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 25,
      page: 0,
      pages: -1,
      search: '',
      sorted: [],
      filtered: [],
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ option: event.target.value }, () =>
      this.table.fireFetchData(),
    );
  }

  fetchData = (state) => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getOutreaches({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: filters,
        tenantId: this.props.tenantId,
      })
      .then((response) =>
        this.setState({
          pages: response.payload
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  editOutreach = (id) => {
    hashHistory.push(`/outreach-manager/outreach/${id}`);
  };

  addOutreach = (id) => {
    hashHistory.push(`/outreach-manager/outreach/${id}`);
  };

  //detailOutreach = (taskId) => {
  //  hashHistory.push(`/outreach-manager/detail/${id}`);
  //};

  //showAll() {
  //  this.setState({ option: 0 }, () => this.table.fireFetchData());
  //}

  //assignedToMe() {
  //  this.setState({ option: 3 }, () => this.table.fireFetchData());
  //}

  //createdByMe() {
  //  this.setState({ option: 4 }, () => this.table.fireFetchData());
  //}
  
  render() {
    const { data } = this.props;
    return (
      <div id="content">
        <Helmet title={`Outreach Manager – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Administration', 'Outreach Manager']}
              icon="fa fa-fw fa-database"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>Outreach Manager</h2>
                  <div className="widget-toolbar">
                    <button 
                      className="btn btn-primary "
                      onClick={() => this.addOutreach('00000000-0000-0000-0000-000000000000')}
                    >
                      Add Outreach
                    </button>
                  </div>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.data.isLoading}
                      data={this.props.data ? this.props.data.data.list : []}
                      onFetchData={this.fetchData}
                      columns={[
                        {
                          Header: 'Id',
                          id: 'id',
                          accessor: 'id',
                          show: false,
                        },
                        {
                          Header: '',
                          id: 'actions',
                          width: 100,
                          sortable: false,
                          Cell: (row) => (
                            <span>
                              <button
                                className="btn btn-default btn-xs"
                                onClick={() =>
                                  this.editOutreach(row.original.id)
                                }
                              >Edit                              
                              </button>
                            </span>
                          ),
                        },
                        {
                          Header: 'Date',
                          accessor: 'date',
                          Cell: (row) => (
                            <Moment
                              date={row.original.date}
                              format="MM/DD/YYYY"
                            />
                          ),
                        },
                        {
                          Header: 'Advocate Name',
                          id: 'createdByName',
                          accessor: 'createdByName',
                        },
                        {
                          Header: 'Outreach Type',
                          id: 'typeName',
                          accessor: 'typeName',
                        },
                        {
                          Header: 'Notes',
                          id: 'note',
                          accessor: 'note',
                        }, 
                        {
                          Header: 'Next Follow-up',
                          accessor: 'nextFlowUpAt',
                          Cell: (row) => ((row.original.nextFlowUpAt == null) ? '' :
                            <Moment
                              date={row.original.nextFlowUpAt}
                              format="MM/DD/YYYY"
                            />
                          ),
                        },
                        {
                          Header: 'Athena Case',
                          id: 'copyToAthena',
                          accessor: 'copyToAthena',
                        },
                      ]}
                      sortable={true}
                      defaultSorted={[
                        {
                          id: 'date',
                          desc: true,
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      className="-striped -highlight"
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.handleSearch}
                    />
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  state => ({
    data: state.outreach,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getOutreaches: (params) => dispatch(requestOutreaches(params)),
  }),
)(OutreachManager);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/OutreachManager.js